import { render, staticRenderFns } from "./ColumnProxy.vue?vue&type=template&id=5351a6e2&scoped=true"
import script from "./ColumnProxy.vue?vue&type=script&lang=ts"
export * from "./ColumnProxy.vue?vue&type=script&lang=ts"
import style0 from "./ColumnProxy.vue?vue&type=style&index=0&id=5351a6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5351a6e2",
  null
  
)

export default component.exports